import React, { useState } from "react";
import { customerApis } from "@payping/api";
import { Typography, Upload, message } from "@payping/web-components";
import { Upload as UploadIcon } from "@payping/icons";
import type { UploadChangeParam, UploadFile } from "@payping/web-components/components/upload/types";
import { useAppTranslation } from "@/utils/useAppTranslation";

const Uploader: React.FC = () => {
  const { t } = useAppTranslation();

  const [fileList, setFileList] = useState<UploadFile[]>([]);

  function onChange(info: UploadChangeParam): void {
    const { status } = info.file;
    // if (status !== "uploading") {
    // }
    if (status === "done") {
      message.success({ content: `${info.file.name} file uploaded successfully.` });
    } else if (status === "error") {
      message.error({ content: `${info.file.name} file upload failed.` });
    }
    setFileList(info.fileList);
  }

  return (
    <Upload.Dragger
      listType={"picture"}
      allowedExtensions={["xls", "xlsx"]}
      name={"file"}
      multiple={true}
      fileList={fileList}
      onChange={onChange}
      requestFunction={(file) => customerApis.customerBulkWithExcelPost(file)}
      className={"dragger-upload"}
    >
      <UploadIcon width={"40px"} />
      <Typography>{t("customer.createBulk.leaveYourExcelHere", { type: "Excel" })}</Typography>
    </Upload.Dragger>
  );
};

export default Uploader;
